export default __webpack_public_path__ + "static/media/AMAZONITA.28b51ff6.jpg";